import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
    determineIfProductCategoryMustBeSimple,
    transformProducts,
    transformProductSystems,
} from '@/helpers/Products/ProductHelper';
import ProductCategoriesRepository from '@/repositories/ProductCategoriesRepository';
import { RouteNames } from '@/enums/routes/RouteNames';
import router from '@/router';

interface Props {
    shouldPickerBeLocked?: boolean;
    productCategoryId: string;
    clientId?: string | null;
    clientsPaymentTypeId?: string | null;
    selectedOfferId?: string | null;
    projectId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorProductSelector',
  props: {
    shouldPickerBeLocked: { type: Boolean, default: false },
    productCategoryId: null,
    clientId: { default: null },
    clientsPaymentTypeId: { default: null },
    selectedOfferId: { default: null },
    projectId: null
  },
  setup(__props: any) {

const props = __props as { shouldPickerBeLocked: boolean, productCategoryId: string, clientId: string | null, clientsPaymentTypeId: string | null, selectedOfferId: string | null, projectId: string };



const productsByCategoryId = computed(() => {
    if (props.productCategoryId === null) {
        return [];
    }

    const categoryById = ProductCategoriesRepository.getById(props.productCategoryId);
    if (categoryById == null) {
        return [];
    }

    return categoryById.products;
});
const productSystems = computed(() => productsByCategoryId.value.map((product) => product.productSystems).flat());
const itemsToDisplay = computed(() => {
    if (determineIfProductCategoryMustBeSimple(props.productCategoryId)) {
        return transformProductSystems(productSystems.value);
    }
    return transformProducts(productsByCategoryId.value);
});

const productClick = (product: any) => {
    router.push({
        name: RouteNames.calculatorProduct,
        params: { productId: product.productId, productFormId: product.productFormId },
        query: {
            projectId: props.projectId,
            offerId: props.selectedOfferId,
            clientId: props.clientId,
            productSystemName: product.isProductCustom ? null : product.productSystemCode,
        },
    });
};

return { __sfc: true,props, productsByCategoryId, productSystems, itemsToDisplay, productClick }
}

})